// src/features/SalesPerson/page/Category

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { icdType } from '../../types/icdType';
import { useTranslation } from 'react-i18next';

const Icd = () => {
    const { t } = useTranslation();

    // Define columns for the Category table
    const CategoryColumns: ColumnsType<icdType> = [
        { title: "Code", dataIndex: "code", key: "code", sorter: true },
        { title: "ShortDescription", dataIndex: "shortDescription", key: "shortDescription" },
        { title: "ShortDescriptionAr", dataIndex: "shortDescriptionAr", key: "shortDescriptionAr" },
        //{ title: "Description", dataIndex: "description", key: "description" },
        //{ title: "DescriptionAr", dataIndex: "descriptionAr", key: "descriptionAr" },
    ];

    return (
        <div>
            <DynamicTable<icdType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.ICD.SEARCH_ICD} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.ICD.ICD} // Unique query key for menus
                columns={CategoryColumns}
                tableTitle={"ICD"}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.ICD.DELETE_ICD}
                deletePayloadField="code"
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "code", placeholder:  t("Search by Code")  },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.ICD.EXPORT_ICD,
                            fileName: "ICD",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Code", key: "code" },
                                { header: "Short Description", key: "shortDescription" },
                                { header: "Short Description Arabic", key: "shortDescriptionAr" },
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default Icd;